import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { ViewType } from 'src/app/models/server/enums/view-type';
import { View } from 'src/app/models/server/view';
import { ViewsStateService } from 'src/app/services/state/views-state.service';
import { FoldersListBoxesSelectorComponent } from './folders-list-boxes-selector/folders-list-boxes-selector.component';

@Component({
    selector: 'app-folders-list-boxes-selector-container',
    templateUrl: './folders-list-boxes-selector-container.component.html',
    styleUrls: ['./folders-list-boxes-selector-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, FoldersListBoxesSelectorComponent, MatIconModule]
})
export class FoldersListBoxesSelectorContainerComponent implements OnInit, OnDestroy {
    /**
     * Références des Enums utilisées dans le template.
     */
    ViewType = ViewType;

    /**
     * Utilisé pour gérer la désincription des observables lorsque le composant est détruit.
     */
    protected componentDestroyed$: Subject<void> = new Subject<void>();

    private view$ = new BehaviorSubject<View>(null);

    public _internalView: View;

    @Input()
    set view(value) {
        this.view$.next(value);
    }

    get view() {
        return this.view$.getValue();
    }

    public listSelectorIsOpen: boolean = true;

    constructor(
        private viewsStateService: ViewsStateService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        document.body.classList.add('list-selector-width-hidden');
        this.subscribeToViewSelectionChangeEvent();
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    /* Ouverture et fermeture du menu */
    public listSelectorClick(isOpen: boolean): void {
        this.listSelectorIsOpen = isOpen;

        if (isOpen) {
            this.RemoveAllClass();
            document.body.classList.add('list-selector-width-normal');
        } else {
            this.RemoveAllClass();
            document.body.classList.add('list-selector-width-small');
        }

        this.cdr.markForCheck();
    }

    private RemoveAllClass(): void {
        document.body.classList.remove(`list-selector-width-small`);
        document.body.classList.remove(`list-selector-width-hidden`);
        document.body.classList.remove(`list-selector-width-normal`);
    }

    /**
     * S'abonne aux événements de changement de vue sélectionnée.
     */
    private subscribeToViewSelectionChangeEvent() {
        this.view$.pipe(takeUntil(this.componentDestroyed$)).subscribe((x: View) => {
            this._internalView = x;

            if (!!x) {
                this._internalView = x;

                if (this.view.viewType === ViewType.Box || this.view.viewType === ViewType.ArchivingBox) {
                    this.RemoveAllClass();
                    document.body.classList.add('list-selector-width-normal');
                } else {
                    this.RemoveAllClass();
                    document.body.classList.add('list-selector-width-hidden');
                }
            }

            this.cdr.markForCheck();
        });
    }
}
